import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
interface FloatingActionBarProps {
  linkedCount: number;
  onReviewClick: () => void;
  showSkippedCount?: boolean;
  skippedCount?: number;
}
const FloatingActionBar = ({
  linkedCount,
  onReviewClick,
  showSkippedCount,
  skippedCount = 0
}: FloatingActionBarProps) => {
  if (linkedCount === 0) return null;
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} exit={{
    y: 100,
    opacity: 0
  }} className="fixed bottom-0 left-0 right-0 p-4 z-40" data-id="element-119">
      <div className="max-w-7xl mx-auto" data-id="element-120">
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 flex items-center justify-between" data-id="element-121">
          <div className="flex items-center space-x-3" data-id="element-122">
            <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-123">
              <CheckCircleIcon className="h-5 w-5 text-blue-600" data-id="element-124" />
            </div>
            <div data-id="element-125">
              <p className="font-medium text-gray-900" data-id="element-126">
                {linkedCount} {linkedCount === 1 ? 'Change' : 'Changes'} to
                Review
              </p>
              <p className="text-sm text-gray-500" data-id="element-127">
                {showSkippedCount ? `${linkedCount - skippedCount} to link • ${skippedCount} to skip` : 'Review and confirm your changes'}
              </p>
            </div>
          </div>
          <motion.button onClick={onReviewClick} className="bg-blue-600 text-white px-4 py-2 rounded-md flex items-center font-medium hover:bg-blue-700" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-128">
            Review & Confirm
            <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-129" />
          </motion.button>
        </div>
      </div>
    </motion.div>;
};
export default FloatingActionBar;